import Icon from 'components/Icon/Icon.react';
import React from 'react';
import styles from './BrowserToolbarButton.scss';

export default function BrowserToolbarButton(props) {
  return (
    <div className={styles.wrap}>
      <div className={styles.entry} onClick={props.onClick}>
        <Icon name={props.icon} width={16} height={16} />
        <span>{props.name}</span>
      </div>
    </div>
  );
}
